import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSetRecoilState } from 'recoil';
import { selectedCoachIdAtom } from '../atoms/coach.atoms';

// 특정한 path에서만 path의 state를 가지고 선택된 코치의 id를 설정하는 hook
export default function useSetCoachIdByPathState() {
  const setSelectedCoachId = useSetRecoilState(selectedCoachIdAtom);
  const { state } = useLocation();

  useEffect(() => {
    if (state?.coachId) {
      setSelectedCoachId(state.coachId);
    }
  }, [state]);
}
